<div class="header-wrapper">
  <h2 class="section-header">
    {{ translationService.getPlasticsText() }}
  </h2>
</div>

@if (declaration) {
  <mat-card class="declaration-card">
    <mat-card-content>
      <div class="declaration-item">
        <mat-icon>layers</mat-icon>
        <span class="label">
          {{ translationService.getProductMaterialTypeText() }}:
        </span>
        <span class="value">
          {{ materialTypeLabel(declaration.productMaterialType) }}
        </span>
      </div>
      <div class="declaration-item tags-section">
        <mat-icon>sell</mat-icon>
        <span class="label">Tags:</span>
        <span class="value tags-value">
          @if (declaration.tags?.length) {
            <mat-chip-set>
              @for (tag of declaration.tags; track tag) {
                <mat-chip>{{ tag }}</mat-chip>
              }
            </mat-chip-set>
          } @else {
            {{ translationService.getNaText() }}
          }
        </span>
      </div>

      @if (isPlasticProduct() || isRawResin()) {
        @if (isRawResin()) {
          <div class="declaration-item">
            <mat-icon>scale</mat-icon>
            <span class="label">
              {{ translationService.getProductWeightKgText() }}:
            </span>
            <span class="value">
              {{
                declaration.productWeightKg ?? translationService.getNaText()
              }}
            </span>
          </div>
        }

        <div class="declaration-item">
          <mat-icon>water</mat-icon>
          <span class="label">
            {{ translationService.getSourceTypeText() }}:
          </span>
          <span class="value">
            {{
              declaration.sourceType
                ? (declaration.sourceType | titlecase)
                : translationService.getNaText()
            }}
          </span>
        </div>

        @if (isPlasticProduct()) {
          <div class="declaration-item">
            <mat-icon>delete</mat-icon>
            <span class="label"
              >{{ translationService.getWasteStreamText() }}:</span
            >
            <span class="value">
              {{
                getWasteStreamText(
                  declaration.isResidentialWasteStream,
                  declaration.isIciWasteStream,
                  declaration.isCdrWasteStream
                )
              }}
            </span>
          </div>
        }

        <div class="declaration-item">
          <mat-icon>business</mat-icon>
          <span class="label">
            {{ translationService.getSupplierText() }}:
          </span>
          <span class="value">
            {{ declaration.supplier ?? translationService.getNaText() }}
          </span>
        </div>

        @if (isPlasticProduct()) {
          <div class="declaration-item">
            <mat-icon>category</mat-icon>
            <span class="label">
              {{ translationService.getCategoryText() }}:
            </span>
            <span class="value">
              {{ declaration.category ?? translationService.getNaText() }}
            </span>
          </div>
          <div class="declaration-item">
            <mat-icon>label</mat-icon>
            <span class="label">
              {{ translationService.getSubcategoryText() }}:
            </span>
            <span class="value">
              {{ declaration.subcategory ?? translationService.getNaText() }}
            </span>
          </div>
          <div class="declaration-item">
            <mat-icon>calculate</mat-icon>
            <span class="label">
              {{ translationService.getCalculationMethodText() }}:
            </span>
            <span class="value">
              {{
                declaration.calculationMethod ?? translationService.getNaText()
              }}
            </span>
          </div>

          @if (isCalculationMethodOther(declaration.calculationMethod)) {
            <div class="declaration-item">
              <mat-icon>edit</mat-icon>
              <span class="label">
                {{ translationService.getSpecifiedCalculationMethodText() }}:
              </span>
              <span class="value">
                {{
                  declaration.calculationMethodOther ??
                    translationService.getNaText()
                }}
              </span>
            </div>
          }
        }

        <div class="declaration-item">
          <mat-icon>event</mat-icon>
          <span class="label">
            {{ translationService.getReportingDateText() }}:
            <mat-icon
              matTooltip="{{
                translationService.getReportingDateTooltipText()
              }}"
              class="info-icon"
              inline
              >info</mat-icon
            >
          </span>
          <span class="value">
            {{
              declaration.reportingDate
                ? (declaration.reportingDate | date: 'longDate')
                : translationService.getNaText()
            }}
          </span>
        </div>

        @if (isPlasticProduct()) {
          @if (isPlasticProduct()) {
            <div class="declaration-item napcs-header">
              <mat-icon>list_alt</mat-icon>
              <span class="label">
                {{ translationService.getResinsText() }}
              </span>
            </div>

            @if (declaration.plasticResins.length) {
              @for (
                resin of declaration.plasticResins;
                track resin.napcsCodeId;
                let last = $last
              ) {
                <div class="declaration-item nested">
                  <mat-icon>qr_code_2</mat-icon>
                  <span class="label">
                    {{ translationService.getResinCodeText() }}:
                  </span>
                  <span class="value">
                    {{
                      resin.napcsCode?.resinCode ??
                        translationService.getNaText()
                    }}
                  </span>
                </div>

                <div class="declaration-item nested">
                  <mat-icon>description</mat-icon>
                  <span class="label">
                    {{ translationService.getFullResinTitleText() }}:
                  </span>
                  <span class="value">
                    {{
                      resin.napcsCode?.fullResinTitle ??
                        translationService.getNaText()
                    }}
                  </span>
                </div>

                <div class="declaration-item nested">
                  <mat-icon>tag</mat-icon>
                  <span class="label">
                    {{ translationService.getNapcsCodeText() }}:
                  </span>
                  <span class="value">
                    {{
                      resin.napcsCode?.napcsCode ??
                        translationService.getNaText()
                    }}
                  </span>
                </div>

                <div class="declaration-item nested">
                  <mat-icon>water</mat-icon>
                  <span class="label">
                    {{ translationService.getSourceTypeText() }}:
                  </span>
                  <span class="value">
                    {{
                      resin.sourceType
                        ? (resin.sourceType | titlecase)
                        : translationService.getNaText()
                    }}
                  </span>
                </div>

                <div class="declaration-item nested">
                  <mat-icon>scale</mat-icon>
                  <span class="label">
                    {{ translationService.getResinWeightKgText() }}:
                  </span>
                  <span class="value">
                    {{
                      resin.weightPerUnitKg ?? translationService.getNaText()
                    }}
                  </span>
                </div>

                @if (!last) {
                  <mat-divider class="resin-divider"></mat-divider>
                }
              }
            } @else {
              <div class="declaration-item nested">
                <span class="value">
                  {{ translationService.getNoResinsFoundText() }}
                </span>
              </div>
            }
          } @else if (isRawResin()) {
            <div class="declaration-item napcs-header">
              <mat-icon>list_alt</mat-icon>
              <span class="label">
                {{ translationService.getNapcsDetailsText() }}
              </span>
            </div>
            <div class="declaration-item nested">
              <mat-icon>qr_code_2</mat-icon>
              <span class="label">
                {{ translationService.getResinCodeText() }}:
              </span>
              <span class="value">
                {{
                  declaration.napcsCode?.resinCode ??
                    translationService.getNaText()
                }}
              </span>
            </div>
            <div class="declaration-item nested">
              <mat-icon>description</mat-icon>
              <span class="label">
                {{ translationService.getFullResinTitleText() }}:
              </span>
              <span class="value">
                {{
                  declaration.napcsCode?.fullResinTitle ??
                    translationService.getNaText()
                }}
              </span>
            </div>
            <div class="declaration-item nested">
              <mat-icon>tag</mat-icon>
              <span class="label">
                {{ translationService.getNapcsCodeText() }}:
              </span>
              <span class="value">
                {{
                  declaration.napcsCode?.napcsCode ??
                    translationService.getNaText()
                }}
              </span>
            </div>
          }
        }
      }
    </mat-card-content>
  </mat-card>
}
